import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import FloatingBackButton from './components/FloatingBackButton';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import BrandingService from './pages/services/BrandingService';
import WebDesignService from './pages/services/WebDesignService';
import PrintDesignService from './pages/services/PrintDesignService';
import DigitalMarketingService from './pages/services/DigitalMarketingService';
import Portfolio from './pages/Portfolio';
import Process from './pages/Process';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/branding" element={<BrandingService />} />
            <Route path="/services/web-design" element={<WebDesignService />} />
            <Route path="/services/print-design" element={<PrintDesignService />} />
            <Route path="/services/digital-marketing" element={<DigitalMarketingService />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/process" element={<Process />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
          </Routes>
        </main>
        <Footer />
        <FloatingBackButton />
      </div>
    </Router>
  );
}

export default App;